import { onMounted, onUnmounted, watch } from 'vue'
import { useDocumentVisibility, useWindowFocus } from '@vueuse/core'

/**
 * Полит-функция, которая вызывает fn() каждые `interval` мс,
 * но ТОЛЬКО когда вкладка видима и в фокусе.
 * Дополнительно дёргает fn при возвращении фокуса.
 */
export function useAutoRefresh(fn: () => void | Promise<void>, interval = 30_000): void {
  const visibility = useDocumentVisibility()
  const focused = useWindowFocus()
  let timer: number | undefined

  const start = () => {
    stop()
    timer = window.setInterval(() => {
      if (visibility.value === 'visible' && focused.value) {
        void fn()
      }
    }, interval)
  }

  const stop = () => {
    if (timer !== undefined) {
      clearInterval(timer)
      timer = undefined
    }
  }

  onMounted(start)
  onUnmounted(stop)

  watch(focused, (isFocused) => {
    if (isFocused) void fn()
  })
}
